/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"
import { theme } from "styles/theme"

export const createMenuContainer = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const stepContentContainer = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const stepsActionStyle = css`
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: ${theme.shadow.default};
  border-radius: 8px;

  p {
    font-weight: 500;
    margin-bottom: 10px !important;
    &.error {
      font-weight: unset;
      color: ${theme.colors.error};
    }
  }

  .button-container {
    button {
      width: 160px;
      height: 60px;
    }
  }

  &.error {
    border-color: ${theme.colors.error};
  }
`

export const stepsActionDividerContainer = css`
  position: relative;

  .ant-divider {
    height: calc(100% + 20px * 2);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
`
export const selectStoresStyle = css`
  .input-name {
    label::after {
      margin: 0;
    }
    .page-subtitle {
      margin-bottom: 12px;
    }
    input {
      width: 380px;
    }
  }
`

export const reviewPublishStyle = css`
  display: flex;
  flex-direction: row;

  .store-list {
    margin-left: 50px;
    padding-top: 0;
    flex-grow: 1;
  }
`
